/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const LogicalOperatorDto = {
    And: 'AND',
    Or: 'OR',
    Not: 'NOT'
} as const;
export type LogicalOperatorDto = typeof LogicalOperatorDto[keyof typeof LogicalOperatorDto];


export function instanceOfLogicalOperatorDto(value: any): boolean {
    for (const key in LogicalOperatorDto) {
        if (Object.prototype.hasOwnProperty.call(LogicalOperatorDto, key)) {
            if (LogicalOperatorDto[key as keyof typeof LogicalOperatorDto] === value) {
                return true;
            }
        }
    }
    return false;
}

export function LogicalOperatorDtoFromJSON(json: any): LogicalOperatorDto {
    return LogicalOperatorDtoFromJSONTyped(json, false);
}

export function LogicalOperatorDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LogicalOperatorDto {
    return json as LogicalOperatorDto;
}

export function LogicalOperatorDtoToJSON(value?: LogicalOperatorDto | null): any {
    return value as any;
}

export function LogicalOperatorDtoToJSONTyped(value: any, ignoreDiscriminator: boolean): LogicalOperatorDto {
    return value as LogicalOperatorDto;
}

